document.addEventListener("DOMContentLoaded", function () {
  const colorSelect = document.getElementById("color-select");
  const tableContainer = document.getElementById("quick-order-table-container");

  colorSelect.addEventListener("change", function () {
    const selectedColor = this.value;
    fetch(`/products/{{ product.handle }}?variant=${selectedColor}`)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const tableHtml = doc.querySelector(".quick-order-list__table");
        tableContainer.innerHTML = tableHtml
          ? tableHtml.outerHTML
          : "<p>Keine Varianten gefunden.</p>";
      });
  });
});
